import { render, staticRenderFns } from "./BpLiabilitiesRatioDisplayer.vue?vue&type=template&id=69d09be5"
import script from "./BpLiabilitiesRatioDisplayer.vue?vue&type=script&lang=ts"
export * from "./BpLiabilitiesRatioDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports